import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.515 5.355 20.812 2h2.796L4.002 22H1.209l4.603-4.683a16.628 16.628 0 0 1-1.66-1.493 20.232 20.232 0 0 1-2.11-2.553A23.465 23.465 0 0 1 1 11.582c.324-.58.668-1.14 1.042-1.688a20.232 20.232 0 0 1 2.11-2.553C6.476 4.964 9.105 3.516 12 3.516c1.964 0 3.807.667 5.515 1.839ZM7.223 15.875l1.713-1.751a4.072 4.072 0 0 1-.881-2.542C8.055 9.355 9.82 7.55 12 7.55c.943 0 1.808.338 2.486.902l1.6-1.636C14.777 5.99 13.409 5.533 12 5.533c-2.285 0-4.464 1.2-6.454 3.233A17.997 17.997 0 0 0 3.3 11.582c.674 1.002 1.404 1.955 2.246 2.816a14.197 14.197 0 0 0 1.677 1.477Zm5.853-5.983A1.933 1.933 0 0 0 12 9.566c-1.09 0-1.973.903-1.973 2.016 0 .406.118.784.32 1.1l2.73-2.79Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.477 19.274a8.75 8.75 0 0 0 2.523.374c2.894 0 5.523-1.447 7.849-3.824A20.002 20.002 0 0 0 23 11.582a20.66 20.66 0 0 0-2.515-3.559l-1.397 1.428c.589.671 1.113 1.39 1.612 2.131-.669 1.001-1.406 1.958-2.246 2.816-1.99 2.034-4.17 3.234-6.454 3.234-.289 0-.575-.02-.86-.057l-1.663 1.7Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionHide24 = createIcon(IconComponent);